<app-header
  [visibleActions]="false"
  [disableNavigationBtns]="true"
></app-header>

<div class="terms-of-service" [innerHTML]="terms()"></div>
